import React, { useEffect, useState } from "react";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import "./sidebardata.css";

function Milestone(props) {
  const { milestone } = props;
  const [milestonetabheader, setMilestonetabheader] = useState([]);
  const [value, setValue] = useState("");

  const getmilestoneData = () => {
    const temp = [];
    milestone.data.map((i) => {
      const obj = {
        milestonefor: i?.routingTimeLine?.eventNodes[0]?.milestonefor ?? "",
        parentjob: i?.routingTimeLine?.eventNodes[0]?.parentjob ?? "",
        eventNodes: [...i?.routingTimeLine?.eventNodes],
      };
      if (obj.milestonefor !== "") {
        temp.push(obj);
      }
    });
    setValue(temp[0]?.parentjob);
    setMilestonetabheader([...temp]);
  };

  useEffect(() => {
    getmilestoneData();
  }, []);

  if (milestone.loading) {
    return (
      <div className="sidebarDataSection container-fluid milestoneSection">
        <div
          className="loadingContent"
          style={{
            height: "100%",
          }}
        >
          <CircularProgress />
        </div>
      </div>
    );
  }
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Box sx={{ width: "100%", typography: "body1" }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList
            onChange={handleChange}
            aria-label="lab API tabs example"
            variant="scrollable"
          >
            {milestonetabheader.map((item) => {
              if (item.milestonefor || item.parentjob) {
                return (
                  <Tab
                    label={`${item.parentjob}(${item.milestonefor})`}
                    value={item.parentjob}
                  />
                );
              }
            })}
          </TabList>
        </Box>
        {milestonetabheader.map((i) => {
          return (
            <TabPanel value={i.parentjob}>
              {
                <div className="sidebarDataSection container-fluid milestoneSection">
                  {i.eventNodes.length ? (
                    <div className="milestonebody">
                      {i.eventNodes.map((item, index) => {
                        let date = item.VisisbleNote
                          ? item.VisisbleNote[Object.keys(item.VisisbleNote)[0]]
                          : "";
                        date = date.substring(0, 5);

                        date = date.split("/");

                        const months = {
                          "01": "Jan",
                          "02": "Feb",
                          "03": "Mar",
                          "04": "Apr",
                          "05": "May",
                          "06": "Jun",
                          "07": "Jul",
                          "08": "Aug",
                          "09": "Sep",
                          10: "Oct",
                          11: "Nov",
                          12: "Dec",
                        };
                        date = [months[date[1]], date[0]];
                        if (index === 0) {
                          return (
                            <div className="completed">
                              <div className="circleFirstOnlyDiv">
                                <p>Start</p>
                              </div>
                              <img
                                src={item.milestoneIconPath}
                                alt="aboveline"
                              />
                              <div className="circleDiv">
                                {date[1] && date[0] ? (
                                  <>
                                    <p>{date[1]}</p>
                                    <p>{date[0]}</p>
                                  </>
                                ) : (
                                  <p>N/A</p>
                                )}
                              </div>
                              <div className="circleDivData">
                                <p title={item.eventName}>{item.eventName}</p>
                              </div>
                            </div>
                          );
                        }

                        return (
                          <div className="completed">
                            <img src={item.milestoneIconPath} alt="belowline" />
                            <div
                              className="circleDiv"
                              style={{
                                backgroundColor: item.backgroundColor,
                              }}
                            >
                              {date[1] && date[0] ? (
                                <>
                                  <p>{date[1]}</p>
                                  <p>{date[0]}</p>
                                </>
                              ) : (
                                <p>N/A</p>
                              )}
                            </div>
                            <div className="circleDivData">
                              <p title={item.eventName}>{item.eventName}</p>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <p className="nosidebarDataPara">No Milestone available!</p>
                  )}
                </div>
              }
            </TabPanel>
          );
        })}
      </TabContext>
    </Box>
  );
}

export default Milestone;
